<template>
  <div class="main-container">
    <div>
      <tl-header type="h1">
        <div>FBP Eligibility Rules</div>
      </tl-header>
    </div>

    <div class="permission-alert-msg" v-if="!ifTeamleaderPermission">
      You have only view permission.
    </div>

    <toast-message
      :message="errmsg"
      :isToastEnable="toast"
      type="error"
      @close="(val) => (toast = val)"
    />

    <pop-up-message
      v-if="showSuccessMsg"
      :message="`FBP Eligibility Configure has been successfully created`"
      btnText="Back"
      @back="backfrompopup()"
    />

    <div class="margin-t-l">
      <div class="row" :disabled="!(ifTeamleaderPermission && isEnableFbp)">
        <div class="col-4" :disabled="!showCriteria">
          <tl-select
            name="criteria"
            id="criteria"
            :placeholder="placeHolder"
            :label="selectionLabel"
            :labelText="selectName"
            :options="fbpArray"
            v-model="formData.criteriaObj"
            @change="(val) => {subCriteriaLabel = val.name; resetForm(); changeCriteria(val);}"
          />
        </div>
        <div class="col-3" v-if="selectionLabel == 'Select Slab'">
          <txt
            label="From CTC"
            :autofocus="false"
            :disable="true"
            v-model="formData.criteriaObj.from_ctc"
          ></txt>
        </div>
        <div class="col-3" v-if="selectionLabel == 'Select Slab'">
          <txt
            label="To CTC"
            :autofocus="false"
            :disable="true"
            v-model="formData.criteriaObj.to_ctc"
          ></txt>
        </div>
        <div class="col-3" v-if="subCriteriaLabel && selectionLabel !== 'Select Slab'">
          <tl-select
            name="Sub criteria"
            id="subCriteria"
            :label="subCriteriaLabel"
            labelText="name"
            :options="subCriteriaArray"
            v-model="formData.subCriteriaObj"
            @change="(val) => {formData.subCriteriaObj = val; subCriteriaChange(val);}"
            v-validate="'required'"
            :classname="errors.has('Sub criteria')"
            :errormsg="errors.first('Sub criteria')"
          />
        </div>
      </div>
    </div>

    <div class="error">
      <p class="warning" v-if="showPercError">
        *Value should not exceed 100 for %-Calculation type
      </p>
      <p class="warning" v-if="showFlatError">
        *Value should not exceed 9999999 for Flat-Calculation type
      </p>
    </div>

    <div class="mt-50" v-if="showCtcTable">
      <data-table
        :columns="fbpCtcSlabsColumnNames"
        :tableData="fbpCtcSlabsData"
        class="custom-data-table-class"
        :checkbox="false"
        :withForm="false"
        :showinrow="false"
        :showedit="true"
      >
        <template v-slot:rowcontent="slotprops">
          <p v-if="slotprops.value.column.key == 'name'">
            {{ slotprops.value.record[slotprops.value.column.key] }}
          </p>
          <tl-select
            v-if="slotprops.value.column.key == 'calculation_type'"
            class="custom-width-slotprop"
            name="calculation_type"
            labelText="name"
            v-model="slotprops.value.record[slotprops.value.column.key]"
            @change="(val) => {saveCalculation(val,slotprops.value.record,'calculation_type');}"
            :options="fbpCtcCalcArray"
          />
          <txt
            class="w-100 custom-width-slotprop"
            v-if="slotprops.value.column.key == 'value'"
            :autofocus="false"
            v-float-only
            maxlength="9"
            name="value"
            v-model="slotprops.value.record[slotprops.value.column.key]"
            @change="(val) => {saveValues(val, slotprops.value.record, 'value');}"
          />
        </template>
      </data-table>
    </div>
    <div class="mt-50" v-if="configurationTable">
      <div class="mb-20">
        <span class="text">Click on ‘Edit’ to FBP Component Mapping </span>
      </div>
      <data-table
        :columns="fbpCtcSlabsColumnNames"
        :tableData="configurationData"
        class="custom-data-table-class"
        :checkbox="false"
        :withForm="false"
        :showinrow="true"
        @editStart="initEditStart"
        :showedit= "true"
        :showdelete="false"
        :showhistory="false"
      >
        <template v-slot:rowcontent="slotprops">
          <p v-if="slotprops.value.column.key == 'name'">
            {{ slotprops.value.record.SalaryComponentLegalEntity.name }}
          </p>
          <tl-select
            v-if="slotprops.value.column.key == 'calculation_type'"
            class="custom-width-slotprop"
            v-model="slotprops.value.record[slotprops.value.column.key]"
            @change="(val) => {updateCalculation(val,slotprops.value.record,'calculation_type');}"
            :options="fbpCtcCalcArray"
          />
          <txt
            class="w-100 custom-width-slotprop"
            v-if="slotprops.value.column.key == 'value'"
            :autofocus="false"
            v-float-only
            maxlength="9"
            v-model="slotprops.value.record[slotprops.value.column.key]"
            @change="(val) => {updateValues(val, slotprops.value.record, 'value');}"
          />
        </template>
      </data-table>
    </div>
    
    <div class="saveButton" v-if="(configurationTable || showCtcTable)">
      <btn text="Save" :disabled="showPercError || showFlatError" type="primary" @click="save" />
    </div>

    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="previous" />
          <btn
            text="Next"
            type="primary"
            @click="next"
          />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import * as config from "@/apis/config.js";
export default {
  name: "fbpEligibilityConfig",
  data() {
    return {
      componentKey: 0,
      nameMaxlength: null,
      descriptionMaxlength: null,
      popupType: "Warning",
      popupMessage: "Are you sure you want to delete ?",
      subCriteriaLabel: "",
      showPopup: false,
      showFlatError: false,
      showPercError: false,
      selectedItem: "",
      subCriteriaOption: "",
      criteriaArray: [
        { name: "GRADES" },
        { name: "LEVEL" },
        { name: "LOCATION" },
      ],
      ctcArray: [],
      subCriteriaArray: [],
      subCtcArray: [],
      fbpCtcSlabsData: [],
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      ctcSlabsArray: [],
      componentList: [],
      formData: {
        criteriaObj: "",
        subCriteriaObj: "",
        subcategoryObj: null,
        calculation_type: "",
        value: null,
      },
      showCtcTable: false,
      configurationData: [],
      configurationTable: false,
      showCriteria: true,
      showSave: true,
      fbpEligibilityValue: false,
      role: "",
      fbpCtcCalcArray: ["Flat","% Of Basic"],
      fbpCtcSlabsColumnNames: [
        {
          label: "FBP Component",
          key: "name",
        },
        {
          label: "Calculation Type",
          key: "calculation_type",
        },
        {
          label: "Value",
          key: "value",
        },
      ],
    };
  },
  computed: {
    ...mapState("onboard/fbpEligibilityConfig", {
      fbpDataAll: (state) => state.fbpData,
      dataAll: (state) => state.data,
      isFetching: (state) => state.isFetching,
      isSaving: (state) => state.isSaving,
      isDeleting: (state) => state.isDeleting,
    }),
    ...mapState({
      ctc_slabs: (state) => state.onboard.ctcslab.entityWiseData,
      locations: (state) => state.onboard.locations.data,
      salary_grades: (state) => state.onboard.salary_grades.data,
      levels: (state) => state.onboard.levels.entityWiseData,
      departments: (state) => state.onboard.departments.data,
      legal_entities_info: (state) => state.onboard.legeal_entities.data,
    }),

    selectionLabel() {
      if (this.isBasedOn) {
        return "Select Slab";
      } else {
        return "Select Category";
      }
    },

    placeHolder() {
      if (this.isBasedOn) {
        return "Select Slabs";
      } else {
        return "Select Category";
      }
    },

    editButton (){
      
    },

    selectName() {
      if (this.selectionLabel == "Select Slab") {
        return "slab_name";
      } else {
        return "name";
      }
    },

    fbpArray() {
      if (this.selectionLabel == "Select Slab") {
        return this.ctcArray;
      } else {
        return this.criteriaArray;
      }
    },

    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      legealEntities: "onboard/legal_entities/record",
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    isLoading() {
      return this.isFetching;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: (state) => state.id,
    }),

    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.fbpEligibilityValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.fbpEligibilityValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },

    isEnableFbp() {
      if (this.legealEntities.enable_fbp) {
        return true;
      } else {
        return false;
      }
    },

    isBasedOn() {
      if (this.legealEntities.based_on == "CTC") {
        return true;
      } else {
        return false;
      }
    },
  },

  mounted() {
    this.getAllData();
    this.getFbpComponents();
    this.getOrgLeIdList();
    this.getSlabs();
    this.getLocations();
    this.getGrades();
    this.getLevels();
    this.componentList = [];
  },

  activated() {
    this.getAllData();
    this.getSlabs();
    this.getOrgLeIdList();
    this.setGlobalValidations();
    this.getLocations();
    this.getGrades();
    this.getLevels();
    this.componentList = [];
  },

  methods: {
    ...mapActions("onboard/fbpEligibilityConfig/", {
      act_fetch: "fetchAll",
      act_create: "create",
      act_getData: "fetchData",
      act_getAll: "fetchAllFbpData",
      act_changeEditMode: "changeEditMode",
      act_delete: "delete",
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      getEnableFbp: "onboard/legal_entities/",
      act_fetch_locations: "onboard/locations/fetchAll",
      act_fetch_grades: "onboard/salary_grades/fetchAll",
      act_fetch_levels: "onboard/levels/fetchAll",
      act_fetch_slabs: "onboard/ctcslab/fetchAll",
    }),

    setGlobalValidations() {
      try {
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
        this.descriptionMaxlength = config.MaxLengthSettings.descriptionLength;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    //for fetching ctc slabs
    async getSlabs() {
      this.ctcArray = [];
      if (this.selectionLabel == "Select Slab") {
        try {
          let res = await this.act_fetch_slabs(this.le_id);
          this.ctcArray = res.data.payload;
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      }
    },

    async getAllData() {
      try {
        let res = await this.act_getAll(this.le_id);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    //fetching CTC slabs Eligibility Data
    async fetchData() {
      try {
        let fbp_ctc_slab_id = this.formData.criteriaObj.id;
        const res = await this.act_getData({ fbp_ctc_slab_id });
        this.configurationData = res.data.payload;
        this.componentList = [];
        if (this.configurationData.length > 0) {
          this.fbpCtcSlabsData.map(el => {
            el.SalaryComponentLegalEntity = {
              name: el.name,
              id : el.id,
            }
          })
          let tempArray = [...this.fbpCtcSlabsData];
          tempArray = tempArray.filter(item => !this.configurationData.some(element => element.SalaryComponentLegalEntity.id === item.id));
          // tempArray = tempArray.filter(Boolean);
          this.configurationData = [...this.configurationData, ...tempArray];
          this.getObject();
          // this.configurationData.map(el => {
          //   if(el.calculation_type == ""){
          //     el.calculation_type = null
          //   }
          //   console.log(el.calculation_type);
          // })
          this.configurationTable = true;
          this.showCtcTable = false;
          this.showSave = false;
          // this.componentKey+= 1;
        } else {
          this.showCtcTable = true;
          this.configurationTable = false;
          this.showSave = true;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    //fetching Grades Eligibility Data
    async fetchGradesData() {
      try {
        let fbp_criterias = this.formData.criteriaObj.name;
        let fbp_salary_grade_id = this.formData.subCriteriaObj.id;
        const res = await this.act_getData({
          fbp_criterias,
          fbp_salary_grade_id,
        });
        this.configurationData = res.data.payload;
        this.componentList = [];
        if (this.configurationData.length > 0) {
          this.fbpCtcSlabsData.map(el => {
            el.SalaryComponentLegalEntity = {
              name: el.name,
              id : el.id,
            }
          })

          let tempArray = [...this.fbpCtcSlabsData];
          this.configurationData.map(element => {
            tempArray.map((item, index) => {
              if(element.SalaryComponentLegalEntity.id === item.id){
                delete tempArray[index];
              }
            })
          })
          tempArray = tempArray.filter(Boolean);
          this.configurationData = [...this.configurationData, ...tempArray];
          this.getObject();
          this.configurationTable = true;
          this.showCtcTable = false;
          this.showCriteria = false;
          this.showSave = false;
        } else {
          this.showCtcTable = true;
          this.configurationTable = false;
          this.showSave = true;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    //fetching Location Eligibility Data
    async fetchLocationData() {
      try {
        let fbp_criterias = this.formData.criteriaObj.name;
        let fbp_location_id = this.formData.subCriteriaObj.id;
        const res = await this.act_getData({ fbp_criterias, fbp_location_id });
        this.configurationData = res.data.payload;
        this.componentList = [];
        if (this.configurationData.length > 0) {
          this.fbpCtcSlabsData.map(el => {
            el.SalaryComponentLegalEntity = {
              name: el.name,
              id : el.id,
            }
          })

          let tempArray = [...this.fbpCtcSlabsData];
          this.configurationData.map(element => {
            tempArray.map((item, index) => {
              if(element.SalaryComponentLegalEntity.id === item.id){
                delete tempArray[index];
              }
            })
          })
          tempArray = tempArray.filter(Boolean);
          this.configurationData = [...this.configurationData, ...tempArray];
          this.getObject();
          this.configurationTable = true;
          this.showCtcTable = false;
          this.showCriteria = false;
          this.showSave = false;
        } else {
          this.showCtcTable = true;
          this.configurationTable = false;
          this.showSave = true;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    //fetching Level Eligibility Data
    async fetchLevelData() {
      try {
        let fbp_criterias = this.formData.criteriaObj.name;
        let fbp_level_id = this.formData.subCriteriaObj.id;
        const res = await this.act_getData({ fbp_criterias, fbp_level_id });
        this.configurationData = res.data.payload;
        this.componentList = [];
        if (this.configurationData.length > 0) {
          this.fbpCtcSlabsData.map(el => {
            el.SalaryComponentLegalEntity = {
              name: el.name,
              id : el.id,
            }
          })

          let tempArray = [...this.fbpCtcSlabsData];
         
          let tempConfigData = this.configurationData && this.configurationData.length > 0 && this.configurationData.map(item => {
            if(item.SalaryComponentLegalEntity === null) {
              item.SalaryComponentLegalEntity = {
                name: '',
                id: 0
              }
            }
            return item;
          })
          tempConfigData.map(element => {
            tempArray.map((item, index) => {
              if(element.SalaryComponentLegalEntity.id !== null && element.SalaryComponentLegalEntity.id === item.id){
                delete tempArray[index];
              } 
            })
          })
          tempArray = tempArray.filter(Boolean);
        
          this.configurationData = [...tempConfigData, ...tempArray];
          this.getObject();
          this.configurationTable = true;
          this.showCtcTable = false;
          this.showCriteria = false;
          this.showSave = false;
        } else {
          this.showCtcTable = true;
          this.configurationTable = false;
          this.showSave = true;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    getObject() {
      this.configurationData.map((el) => {
        if (el.calculation_type === "FLAT") {
          el.calculation_type = "Flat";
        } else if (el.calculation_type === "PERCENTAGE_OF_CTC") {
          el.calculation_type = "% Of CTC";
        } else if (el.calculation_type === "PERCENTAGE_OF_BASIC") {
          el.calculation_type = "% Of Basic";
        } else if(el.calculation_type === "PERCENTAGE_OF_GROSS"){
          el.calculation_type = "% Of Gross";
        }else{
          el.calculation_type = null;
        }
      });
    },

    getSubCriteriaList(eventName) {
      switch (eventName) {
        case "LOCATION":
          this.getLocations();
          break;
        case "GRADES":
          this.getGrades();
          break;
        case "LEVEL":
          this.getLevels();
          break;
      }
    },

    //changing Criteria event
    changeCriteria(event) {
      try {
        if (event) {
          this.subCriteriaArray = [];
          this.formData.criteriaObj = event;
          if (event.name == "LOCATION") {
            this.subCriteriaArray = this.locations[this.le_id]
              ? this.locations[this.le_id]
              : [];
          } else if (event.name == "GRADES") {
            this.subCriteriaArray = this.salary_grades[this.le_id]
              ? this.salary_grades[this.le_id]
              : [];
          } else if (event.name == "LEVEL") {
            this.subCriteriaArray = this.levels[this.le_id]
              ? this.levels[this.le_id]
              : [];
          }
          if (this.subCriteriaArray.length == 0) {
            this.getSubCriteriaList(event.name);
          }
          if (this.selectionLabel == "Select Slab") {
            this.componentList = [];
            this.fetchData();
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async getLocations() {
      try {
        let res = await this.act_fetch_locations(this.le_id);
        this.subCriteriaArray = res.data.payload;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getGrades() {
      try {
        let res = await this.act_fetch_grades(this.le_id);
        this.subCriteriaArray = res.data.payload;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getLevels() {
      try {
        let res = await this.act_fetch_levels(this.le_id);
        this.subCriteriaArray = res.data.payload;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    //changing sub criteria event
    subCriteriaChange() {
      if (this.formData.criteriaObj.name == "GRADES") {
        this.componentList = [];
        this.fetchGradesData();
      } else if (this.formData.criteriaObj.name == "LOCATION") {
        this.componentList = [];
        this.fetchLocationData();
      } else {
        this.componentList = [];
        this.fetchLevelData();
      }
    },

    //fetching FBP Components
    async getFbpComponents() {
      try {
        const res = await this.act_fetch(this.le_id);
        this.fbpCtcSlabsData = res.data.payload.data;
        this.fbpCtcSlabsData.forEach((el) => {
          el.calculation_type = "";
          el.value = null;
        });
      } catch (err) {
        //console.log(err);
      }
    },

    //For saving values in data table
    saveCalculation(val, record, key) {
      if (val == "% Of CTC" || val == "% Of Basic" || val == "% Of Gross") {
        if (record.value > 100) {
          this.showPercError = true;
        } else {
          this.showPercError = false;
        }

        record[key] = val;
        let componentDetails = {
          id: record.id,
          calculation_type: record.calculation_type,
          value: record.value,
        };
        let isPresent = this.componentList.some((x) => x.id === record.id);
        if (isPresent) {
          let index = this.componentList.findIndex((x) => x.id === record.id);
          this.componentList[index][key] = record[key];
        } else {
          this.componentList.push(componentDetails);
        }
      } else {
        if (record.value > 9999999) {
          this.showFlatError = true;
        } else {
          this.showFlatError = false;
        }
        record[key] = val;
        let componentDetails = {
          id: record.id,
          calculation_type: record.calculation_type,
          value: record.value,
        };
        let isPresent = this.componentList.some((x) => x.id === record.id);
        if (isPresent) {
          let index = this.componentList.findIndex((x) => x.id === record.id);
          this.componentList[index][key] = record[key];
        } else {
          this.componentList.push(componentDetails);
        }
      }
    },

    saveValues(val, record, key) {
      if (
        record.calculation_type == "% Of CTC" ||
        record.calculation_type == "% Of Basic" ||
        record.calculation_type == "% Of Gross"
      ) {
        if (val > 100) {
          this.showPercError = true;
        } else {
          this.showPercError = false;

          record[key] = val;
          let componentDetails = {
            id: record.id,
            calculation_type: record.calculation_type,
            value: record.value,
          };
          let isPresent = this.componentList.some((x) => x.id === record.id);
          if (isPresent) {
            let index = this.componentList.findIndex((x) => x.id === record.id);
            this.componentList[index][key] = record[key];
          } else {
            this.componentList.push(componentDetails);
          }
        }
      } else {
        if (val > 9999999) {
          this.showFlatError = true;
        } else {
          this.showFlatError = false;

          record[key] = val;
          let componentDetails = {
            id: record.id,
            calculation_type: record.calculation_type,
            value: record.value,
          };
          let isPresent = this.componentList.some((x) => x.id === record.id);
          if (isPresent) {
            let index = this.componentList.findIndex((x) => x.id === record.id);
            this.componentList[index][key] = record[key];
          } else {
            this.componentList.push(componentDetails);
          }
        }
      }
    },

    updateCalculation(val, record, key) {
      if (val === "% Of CTC" || val === "% Of Basic" || val === "% Of Gross") {
        if (record.value > 100) {
          this.showPercError = true;
        } else {
          this.showPercError = false;
        }

        record[key] = val;
        let componentDetails = {
          id: record.SalaryComponentLegalEntity.id,
          calculation_type: record.calculation_type,
          value: record.value,
        };
        let isPresent = this.componentList.some(
          (x) => x.id === record.SalaryComponentLegalEntity.id
        );
        if (isPresent) {
          let index = this.componentList.findIndex(
            (x) => x.id === record.SalaryComponentLegalEntity.id
          );
          this.componentList[index][key] = record[key];
        } else {
          this.componentList.push(componentDetails);
        }
      } else {
        if (record.value > 9999999) {
          this.showFlatError = true;
        } else {
          this.showFlatError = false;
        }
        record[key] = val;
        let componentDetails = {
          id: record.SalaryComponentLegalEntity.id,
          calculation_type: record.calculation_type,
          value: record.value,
        };
        let isPresent = this.componentList.some(
          (x) => x.id === record.SalaryComponentLegalEntity.id
        );
        if (isPresent) {
          let index = this.componentList.findIndex(
            (x) => x.id === record.SalaryComponentLegalEntity.id
          );
          this.componentList[index][key] = record[key];
        } else {
          this.componentList.push(componentDetails);
        }
      }
    },

    updateValues(val, record, key) {
      if (
        record.calculation_type == "% Of CTC" ||
        record.calculation_type == "% Of Basic" ||
        record.calculation_type == "% Of Gross"
      ) {
        if (val > 100) {
          this.showPercError = true;
        } else {
          this.showPercError = false;

          record[key] = val;
          let componentDetails = {
            id: record.SalaryComponentLegalEntity.id,
            calculation_type: record.calculation_type,
            value: record.value,
          };
          let isPresent = this.componentList.some(
            (x) => x.id === record.SalaryComponentLegalEntity.id
          );
          if (isPresent) {
            let index = this.componentList.findIndex(
              (x) => x.id === record.SalaryComponentLegalEntity.id
            );
            this.componentList[index][key] = record[key];
          } else {
            this.componentList.push(componentDetails);
          }
        }
      } else {
        if (val > 9999999) {
          this.showFlatError = true;
        } else {
          this.showFlatError = false;

          record[key] = val;
          let componentDetails = {
            id: record.SalaryComponentLegalEntity.id,
            calculation_type: record.calculation_type,
            value: record.value,
          };
          let isPresent = this.componentList.some(
            (x) => x.id === record.SalaryComponentLegalEntity.id
          );
          if (isPresent) {
            let index = this.componentList.findIndex(
              (x) => x.id === record.SalaryComponentLegalEntity.id
            );
            this.componentList[index][key] = record[key];
          } else {
            this.componentList.push(componentDetails);
          }
        }
      }
    },

    next() {
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/employeeDashboard`
      );
    },

    save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
        }
      });
    },

    //creating FBP Eligibility Configuration
    async performAction() {
      this.componentList.map((el) => {
        if (el.calculation_type === "Flat") {
          el.calculation_type = "FLAT";
        } else if (el.calculation_type === "% Of CTC") {
          el.calculation_type = "PERCENTAGE_OF_CTC";
        } else if (el.calculation_type === "% Of Basic") {
          el.calculation_type = "PERCENTAGE_OF_BASIC";
        } else if (el.calculation_type === "PERCENTAGE_OF_GROSS") {
          el.calculation_type = "PERCENTAGE_OF_GROSS";
        } else{

        }
      });
      
      if (this.selectionLabel == "Select Slab") {
        this.componentList.map((el) => {
          el.fbp_ctc_slab_id = this.formData.criteriaObj.id;
          el.le_id = this.le_id;
          el.fbp_component_id = el.id;
          el.value = Number(el.value);
        });
        try {
          let formData = [...this.componentList];
          const res = await this.act_create({ data: [...formData] });

          if (res.status == 200) {
            this.$root._data.isSaving = false;
            this.showSuccessMsg = true;
            this.fetchData();
          } else {
            this.configurationTable = false;
            this.showCtcTable = true;
          }
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      } else {
        if (this.formData.criteriaObj.name == "GRADES") {
          this.componentList.map((el) => {
            el.fbp_criterias = this.formData.criteriaObj.name,
            el.fbp_salary_grade_id = this.formData.subCriteriaObj.id,
            el.le_id = this.le_id;
            el.fbp_component_id = el.id;
            el.value = Number(el.value);
          });
          try {
            let formData = [...this.componentList];
            const res = await this.act_create({ data: [...formData] });
            if (res.status == 200) {
              this.$root._data.isSaving = false;
              this.showSuccessMsg = true;
              this.fetchGradesData();
            } else {
              this.configurationTable = false;
              this.showCtcTable = true;
            }
          } catch (err) {
            this.toast = true;
            this.errmsg = err;
          }
        } else if (this.formData.criteriaObj.name == "LEVEL") {
          this.componentList.map((el) => {
            el.fbp_criterias = this.formData.criteriaObj.name,
            el.fbp_level_id = this.formData.subCriteriaObj.id,
            el.le_id = this.le_id;
            el.fbp_component_id = el.id;
            el.value = Number(el.value);
          });
          try {
            let formData = [...this.componentList];
            const res = await this.act_create({ data: [...formData] });
            if (res.status == 200) {
              this.$root._data.isSaving = false;
              this.showSuccessMsg = true;
              this.fetchLevelData();
            } else {
              this.configurationTable = false;
              this.showCtcTable = true;
            }
          } catch (err) {
            this.toast = true;
            this.errmsg = err;
          }
        } else {
          this.componentList.map((el) => {
            el.fbp_criterias = this.formData.criteriaObj.name,
            el.fbp_location_id = this.formData.subCriteriaObj.id,
            el.le_id = this.le_id;
            el.fbp_component_id = el.id;
            el.value = Number(el.value);
          });
          try {
            let formData = [...this.componentList];
            const res = await this.act_create({ data: [...formData] });
            if (res.status == 200) {
              this.$root._data.isSaving = false;
              this.showSuccessMsg = true;
              this.fetchLocationData();
            } else {
              this.configurationTable = false;
              this.showCtcTable = true;
            }
          } catch (err) {
            this.toast = true;
            this.errmsg = err;
          }
        }
      }
    },

    async initEditStart(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/fbpMapping`,
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to hide the success pop-up and go back to Designation main page */
    backfrompopup() {
      this.showSuccessMsg = false;
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:", org);
      //console.log("Le ID", le);
      let bodyParams = {};
      let data = await this.getOrgLeList({
        data: {
          ...bodyParams,
        },
      });
      //console.log(data.data);
      this.role = data.data.user.userRole;
      this.fbpEligibilityValue = data.data.user.permissions.fbpEligibilityConfig
        ? true
        : false;
      //console.log("PL-3406", data);
    },

    // reset the form
    resetForm() {
      this.formData = {
        criteriaObj: "",
        subCriteriaObj: "",
        subcategoryObj: null,
        fbpCalcObj: {},
      };
    },

    previous() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/ctcSlab`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/components/margins.scss";

.mt-50 {
  margin-top: 30px;
}

.mb-20 {
  margin-bottom: 20px;
}
.text {
  color: #858585;
  font-size: 14px;
}

.warning {
  color: #842029;
}

.error {
  margin-top: 50px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  border-color: #f5c2c7;
}

.w-100 {
  width: 150px;
}

.saveButton{
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
}
</style>
